const duotoolMerchantsCms = 'http://super.duotool.cn'
const customerServiceQQ = 'https://jq.qq.com/?_wv=1027&amp;k=5L3FBdX'

export { duotoolMerchantsCms, customerServiceQQ }
